import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type IGetTemplatePayload = {
    templateFor: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IGetTemplateState {
    status: string
    data: any
    errors: any
}

const initialState: IGetTemplateState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const getTemplateSlice = createSlice({
    name: 'hub/data-import/get-template',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IGetTemplatePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const getTemplateActions = getTemplateSlice.actions
export default getTemplateSlice.reducer
